var _style, _ellipse, _polyline, _path, _polygon, _path2, _g, _g2, _ellipse2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      width: 166
    },
    xmlSpace: "preserve",
    "data-imageid": "team-presentation-9-12",
    imageName: "Team Presentation 9",
    className: "illustrations_image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0_team-presentation-9-12{fill:#C9D4FF;}\n\t.st1_team-presentation-9-12{fill:url(#SVGID_1_);}\n\t.st2_team-presentation-9-12{fill:url(#SVGID_00000122709556667476445180000005022713913984252053_);}\n\t.st3_team-presentation-9-12{fill:url(#SVGID_00000127733766516804922210000000716617508729510797_);}\n\t.st4_team-presentation-9-12{opacity:0.57;fill:url(#SVGID_00000174565551689174707280000001791619774352474781_);enable-background:new    ;}\n\t.st5_team-presentation-9-12{fill:#175ABC;}\n\t.st6_team-presentation-9-12{fill:#68E1FD;}\n\t.st7_team-presentation-9-12{fill:#FF666D;}\n\t.st8_team-presentation-9-12{fill:#FBB5AD;}\n\t.st9_team-presentation-9-12{fill:#AF3E2F;}\n\t.st10_team-presentation-9-12{fill:#007058;}\n\t.st11_team-presentation-9-12{fill:#FFC963;}\n\t.st12_team-presentation-9-12{opacity:0.43;fill:#AF3E2F;enable-background:new    ;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Base_team-presentation-9-12",
    className: "st0_team-presentation-9-12",
    cx: 258.4,
    cy: 311.9,
    rx: 219.4,
    ry: 119.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_team-presentation-9-12"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_-team-presentation-9-12",
    gradientUnits: "userSpaceOnUse",
    x1: 122.3973,
    y1: -1087.8134,
    x2: 210.7673,
    y2: -1160.1732,
    gradientTransform: "matrix(1 0 0 1 0 1464.1499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E2F",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F47DD"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1_team-presentation-9-12",
    points: "161.2,321.4 77.9,370 121.9,398.5 206,350.8 \t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104695687574457966300000007007610362179602073_-team-presentation-9-12",
    gradientUnits: "userSpaceOnUse",
    x1: 234.2798,
    y1: -1059.7202,
    x2: 295.5497,
    y2: -1109.8704,
    gradientTransform: "matrix(1 0 0 1 0 1464.1499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E2F",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F47DD"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000104695687574457966300000007007610362179602073_)"
    },
    points: "251.8,374.1 205.8,403  224,423.1 289.8,383.7 \t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117664182861478688340000009127059034164919486_-team-presentation-9-12",
    gradientUnits: "userSpaceOnUse",
    x1: 81.8116,
    y1: -1134.948,
    x2: 146.1816,
    y2: -1187.6479,
    gradientTransform: "matrix(1 0 0 1 0 1464.1499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E2F",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F47DD"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000117664182861478688340000009127059034164919486_)"
    },
    points: "103.9,300.1 55.2,321.4  65.4,344.1 141.9,309.6 \t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000187087642347746090000012496553622796358786_-team-presentation-9-12",
    gradientUnits: "userSpaceOnUse",
    x1: 338.6098,
    y1: -1118.3003,
    x2: 440.7498,
    y2: -1201.9202,
    gradientTransform: "matrix(1 0 0 1 0 1464.1499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E2F",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F47DD"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      opacity: 0.57,
      fill: "url(#SVGID_00000000187087642347746090000012496553622796358786_)",
      enableBackground: "new"
    },
    points: " 368.4,284.7 280.3,330.1 355.3,375.5 442.1,324.6 \t"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Presentation_Boardv_team-presentation-9-12"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5_team-presentation-9-12",
    d: "M354.8,188.5l10.4,100.2c1.9,1.4,4.5,1.5,6.5,0.3l-11.1-101L354.8,188.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5_team-presentation-9-12",
    points: "419,112.2 435.2,262.2 379.3,233.3 \t"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M386.4,340.8L419,114l-5-1.9L380.1,339C381.6,340.8,384.1,341.6,386.4,340.8z",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M305.2,303.4l32.7-226.8l-5-1.9L299,301.5C300.5,303.4,303,304.1,305.2,303.4z",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5_team-presentation-9-12",
    d: "M421.1,133.1h-5.4l20,191.3c1.9,1.4,4.5,1.5,6.5,0.3L421.1,133.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M419,112.2c-40.6-23.9-79.1-46.4-85.8-49.8l-21.7,155.4l85.4,50.5L419,112.2z",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chair_2_team-presentation-9-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5_team-presentation-9-12",
    cx: 122.1,
    cy: 305.5,
    rx: 22.6,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 261.5,
    className: "st5_team-presentation-9-12",
    width: 7.7,
    height: 41.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7_team-presentation-9-12",
    d: "M97.8,262.9c-0.7-1.7-1.3-3.4-1.8-5.1c-3.4-13.4-5.6-63.4,16.9-61.4c24.7,2.2,16.4,64.1,41.4,62.2 s35.3,4.6,25.1,14.3C158.9,292.3,110.3,292.7,97.8,262.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Character_Presenting_team-presentation-9-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5_team-presentation-9-12",
    points: "225.5,150.2 236,131.3 242,121.6 218.7,110.2 203.8,140.9 \t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M249.9,146.8l-6.6-7.4c-0.6-0.5-1-1-1.5-1.6c-0.4-1-0.5-2.1-0.4-3.1c-0.1-1.5-0.4-3-0.9-4.5 c-0.3-1-1.3-1.5-2.2-1.2c-0.8,0.2-1.3,0.9-1.3,1.7c0,0.9,0,1.9,0.1,2.8l-1.6-1.5c-2.2,4-4.5,7.9-6.8,11.7c1.3,0.1,2.6,0.1,3.9,0 c4.8,2.8,9,6.5,12.5,10.9c0.6,0.7,1.7,0.8,2.4,0.2c0,0,0,0,0,0c0.2-0.2,0.4-0.4,0.5-0.7c0.2,0,0.4-0.1,0.6-0.2h0.1 c0.8-0.5,1.1-1.6,0.7-2.5v-0.1c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.4-0.7-0.9-1.1-1.3l0.2,0.2C248.9,151.1,251.4,148.5,249.9,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M236.3,141.1c-0.7-1-1.2-2.2-1.4-3.4c0.1-1.2,0.5-2.4,1.3-3.4c0.3-0.4-0.4-0.9-0.7-0.4 c-0.9,1.1-1.4,2.4-1.5,3.8c0.2,1.4,0.7,2.7,1.5,3.9c0.1,0.2,0.3,0.3,0.6,0.2C236.4,141.7,236.5,141.4,236.3,141.1 C236.4,141.2,236.3,141.1,236.3,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M353.6,136.7c-1,0.2-2,0.5-3.1,0.8c0.7-0.5,1.2-1.3,1.3-2.2c0.3-0.8-0.1-1.6-0.8-1.9c-0.5-0.2-1-0.1-1.4,0.2 c-2.7,1.4-5.5,2.7-8.3,4.1c0-0.2,0.1-0.4,0.1-0.6c0.4-1.3,0.6-2.6,0.5-4c-0.6-2.3-2.7-1-3.6,0.8c-1.2,2.4-1.5,5.1-3.6,7 c-1.3,0.9-2.7,1.5-4.3,1.7c-1.5,0.4-3.1,0.9-4.7,1.3c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5c-0.7,0.4-0.9,1.3-0.5,2c0,0,0,0,0,0 c0.1,0.2,0.4,0.4,0.6,0.6c-0.7,1.1,0.1,3,1.6,2.3c3.6-1.5,7.4-2.6,11.2-3.3c3.8-0.2,7.6-0.5,11.3-1c1.9-0.2,2-3.2,0-3.1h-0.3 l3.4-0.6c1.7-0.3,1.3-3.2-0.4-3h-0.4l-1.1,0.2l1.6-0.5c1-0.4,1.9-0.6,2.4-1.6c0.5-0.7,0.3-1.6-0.4-2.1 C354.6,136.5,354.1,136.4,353.6,136.7L353.6,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M341.4,139.3c-0.1-0.2-0.3-0.3-0.4-0.2c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.2,0.4c0.5,2-0.1,4.1-1.6,5.4 c-0.3,0.3,0.1,0.8,0.5,0.5C341.3,143.9,342,141.5,341.4,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M350.7,137c-2.5,0.7-4.9,1.4-7.4,2.3c-0.4,0.1-0.2,0.8,0.2,0.7c2.4-0.9,4.9-1.6,7.4-2.3 c0.2-0.1,0.3-0.3,0.2-0.4C351,137.1,350.9,137,350.7,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M352.5,140.5l-7.8,1.2c-0.4,0-0.2,0.7,0.2,0.7l7.8-1.2C353.1,141.1,352.9,140.4,352.5,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M351,144c-2.1,0.1-4.2,0.2-6.3,0.3c-0.4,0-0.5,0.7,0,0.7c2.1-0.1,4.2-0.1,6.3-0.3 C351.5,144.6,351.5,144,351,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M254.3,268.3c0,0-0.2,10-1.4,11.6s-11.7,7.2-12.3,9.7s1.3,6.2,6.3,4.8s17-9.2,17-9.2v-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M294.6,279.7l1.3,10.9c0,0-4.6,16.8-2.8,18.8s8.5,4.2,11.1,0s-1.1-19.9-1.1-19.9l-0.2-11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5_team-presentation-9-12",
    d: "M270.4,164.6c0,0-13,52.9-13.6,61s-4.5,47.6-4.5,47.6s12.4,5.5,20.7,2.7l6.5-49.7l7.3-52.1 C286.9,174.1,273.5,160.8,270.4,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5_team-presentation-9-12",
    d: "M295.4,177.1c9.2,39,10.3,68.5,15,102.7c0,0-19.9,7.3-24.3,0.2c-3-34.8-5.4-69.6-6.5-104.5L295.4,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M332,135.7c-8.4,3.2-18.3,6.1-25.2,5.2c-8.6-1.1-17-3.2-25.1-6.2c-1.1-0.4-13-4.9-17.4-1s-3.3,16.7-3.3,16.7 l-16-13.9c-6,2.1-8.3,8.3-8.9,14.4c0.3,0.3,0.5,0.5,0.6,0.6c1.1,1.3,2.3,2.7,3.5,4c5.3,5.9,11.3,12.8,19.1,15.3 c3.1,0.9,6.4,0.7,9.3-0.6c2.3-0.9,5.7-3.7,8.2-2.7c0.7,0.2,1.3,0.7,1.9,0.6c1.8-0.2,4.3-3.2,6.1-4.1c4.8-2.5,10.4-2.9,15.8-3.2 c5.8-0.2,11.6-0.8,17.3-1.9c1.7-0.4,19.5-4.9,19.9-4.1C334.3,147.8,333.4,143.6,332,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M269.2,123.8c-1.2,5.6-0.2,13.3,5.8,14.2c7.7,1.1,9.6-4.1,9.2-10.5c-0.3-5.1-3-13.1-9.9-10.8 c-1.7,0.6-3.1,1.9-3.9,3.6C269.9,121.3,269.5,122.6,269.2,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M268.8,125c-3.1-1.6-5-5-4.7-8.5c0.3-3.4,3.6-7.8,7.4-6.2c2.6,1.1,1.9,1.2,1.9,1.2c1.2-1.5,3.2-2.2,5.1-1.8 c3.6,0.3,4.3,2.5,4.3,2.5s4.1,1.4,5.2,4c1.2,3-1.6,12-3,14.5s-2.1-2.6-2.6-4.7c-0.3-1.7-1.4-3.1-3-3.8c-2.2-0.6-3.4,1.4-5.1,2.2 C272.6,125.5,270.6,125.7,268.8,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M283.3,179.3c4.8-0.3,7.5-0.4,12.1-2.2l0.8-25.6L265.4,166c0,0,1.2,6.2,2.5,11.9 C272.9,179.3,278.1,179.7,283.3,179.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_Audiences_team-presentation-9-12"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5_team-presentation-9-12",
    cx: 187,
    cy: 339.4,
    rx: 33.7,
    ry: 13.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 276.2,
    className: "st5_team-presentation-9-12",
    width: 5.9,
    height: 67.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7_team-presentation-9-12",
    d: "M161.2,321.9c0.7,1-1,10.6,2.4,13.6s11.4,7.2,9.6,10.1s-28.7-7.4-28.7-7.4l2.5-18.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7_team-presentation-9-12",
    d: "M181.9,313.4c0.7,1-1,10.6,2.4,13.6s11.4,7.2,9.6,10.1s-28.7-7.4-28.7-7.4l2.5-18.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M117.2,258.5c0,0-1.1,11.9,4.5,16.7s25.7,10.5,25.7,10.5s-6.8,32.8-5.6,35.7s15.8,4.6,23.4,0 c0,0,11.2,2.9,18.6-3.9c0,0,14.3-40.5,9.8-53.7S164,246.9,164,246.9L117.2,258.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M121.4,182.8c-1.7-2.9-6.8-6.7-9.8-3.4c-1.2,1.5-1,3.7,0.5,4.9c1.5,1.5,4.1,1.9,6,2.4c0.8,0.3,1.7-0.1,2-1 c0,0,0,0,0,0c0-0.1,0.1-0.3,0.1-0.5c0.9-0.1,1.6-0.9,1.5-1.8c0,0,0,0,0,0C121.7,183.3,121.6,183,121.4,182.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M158.2,237.5l-44.1-10.8c0,0,1.4,19.1,3.1,31.9c7.9,3.5,17.5,3.5,25.9,2.2c5.9-0.7,11.7-2.3,17.1-4.9 c1.7-0.9,3.4-2,5-3.1C164.6,248.1,158.8,242.1,158.2,237.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M161.5,243.2l-4.6-13.8c-4.1-12.4-10.7-29.4-22.3-36.4c-10-0.5-15,3.2-24.2,7.8c-1.3,1.3-2.4,2.7-3.3,4.2 c-1.3,3.6-1.7,7.4-1.3,11.1c2.7,27.7,42.9,41.1,61.5,46.1c0.2-3.5,1.1-11.9,1.1-15.4L161.5,243.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M152.9,258.3c-14.8-4.4-28.2-12.7-38.7-24.1c-0.7-0.7-1.8,0.4-1.1,1.1c10.7,11.5,24.4,20,39.4,24.5 c0.4,0.1,0.8-0.2,0.9-0.7C153.5,258.7,153.2,258.4,152.9,258.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M169.2,245.8c-10.3-4.2-20-9.6-28.9-16.2c-0.8-0.6-1.6,0.8-0.8,1.3c9,6.7,18.9,12.2,29.3,16.4 C169.7,247.7,170.1,246.2,169.2,245.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M134,192.8c0,0,13.5,1.5,20.5,13.9s24.6,25.8,25.3,26.1s8.6,4.2,8.6,4.2s1.1,12.3-3,14.6S155.7,239,155.7,239 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M137.5,173.1c0,0,4.9,22.6-2.6,25.5s-15.1-2.3-16.4-6.6s-0.5-10.8-0.5-10.8S123.6,173.2,137.5,173.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M138.3,169.1c0.2-5.5-7.4-8.9-11-4.3c-1.8-1.5-4.2-2.2-6.5-1.8c-3.3,0.6-4.4,2.9-4.1,5.9 c-1.9,0-3.7,0.9-4.8,2.4c-1.3,1.9-1.3,4.3,0,6.2c-2.4,1-3.8,3.5-3.4,6c0.1,1.1,0.4,2.2,1,3.1c-0.1,0.4-0.2,0.7-0.3,1.1 c-0.3,2.1,0.6,4.2,2.4,5.3c1,0.7,2.2,1.1,3.5,1.1c0.8,1.6,2.5,2.6,4.3,2.5c2.3-0.1,4.1-1.9,4.3-4.1c0-0.6,0-1.2-0.2-1.8 c1-2.3,1.2-4.9,0.5-7.3c0.3-0.1,0.6-0.3,0.9-0.4c0.9-0.6,1.5-1.6,1.8-2.6c1,0.4,2.1,0.5,3.2,0.3c1-0.2,1.9-1,2.2-2 c2.6,0.7,6.4-0.3,7.8-2.7C141.1,173.4,140.4,170.6,138.3,169.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M125.5,188.7c-0.3-1.5-1.1-2.8-2.3-3.6c-1.2-1-3-0.9-4,0.3v0.1c-0.8,1.2-0.7,2.7,0.2,3.8c1,1.3,2.6,1.3,4,1.9 c0.8,0.4,1.4-0.5,1.2-1.2C125.1,189.9,125.6,189.3,125.5,188.7C125.5,188.7,125.5,188.7,125.5,188.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M136,183c-0.1-0.5-0.9-0.3-0.8,0.2l0.7,3.5c0.2,0.5,0.3,1.1,0.3,1.6c0,1-0.5,1.2-1.2,1.6 c-0.2,0.1-0.3,0.4-0.1,0.6c0.1,0.2,0.4,0.3,0.6,0.1c1-0.6,1.8-0.9,1.7-2.1C136.9,186.7,136.5,184.9,136,183z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M137.9,182c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0c0.2,0,0.4-0.2,0.4-0.4l0,0 C138.3,182.2,138.2,182,137.9,182C137.9,182,137.9,182,137.9,182z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M129.9,184.7c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4c0,0,0,0,0,0c0.2,0,0.4-0.2,0.4-0.4 C130.3,184.9,130.1,184.7,129.9,184.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M134.1,192.3c-1.3,0.6-2.9,0.1-3.6-1.2c-0.1-0.2-0.4-0.2-0.6-0.1c-0.1,0.1-0.2,0.3-0.1,0.5 c1,1.6,3,2.3,4.7,1.5C135,192.8,134.6,192.1,134.1,192.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M190.5,244c-27.6,0-50.6,8.7-56.3,20.2l-1.4-1.4v7c0,14.2,25.8,25.8,57.7,25.8s57.7-11.5,57.7-25.8 S222.3,244,190.5,244z",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12_team-presentation-9-12",
    d: "M190.5,244c-27.6,0-50.6,8.7-56.3,20.2l-1.4-1.4v7c0,14.2,25.8,25.8,57.7,25.8s57.7-11.5,57.7-25.8 S222.3,244,190.5,244z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6_team-presentation-9-12 targetColor",
    cx: 190.5,
    cy: 262.9,
    rx: 57.7,
    ry: 25.8,
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M232.3,351.3l2.4,11.1c0,0-7.2-1.3-9.7-1s-5.6,4.8-2.6,7.7s8.4,2.7,13.7,3.9s6.1,1.5,9.5,0.5s3.9-5.6,3.9-5.6 l-2.6-19.4",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M249.8,340.5l3,16.6c0,0-4.8,4.9-20.8,4.3s0-29.4,0-29.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6_team-presentation-9-12 targetColor",
    d: "M213.7,360.4l2.4,11.1c0,0-7.2-1.3-9.7-1s-5.6,4.8-2.6,7.7s8.4,2.7,13.7,3.9s6.1,1.5,9.5,0.5s3.9-5.6,3.9-5.6 l-2.6-19.3",
    style: {
      fill: "rgb(6, 71, 157)"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M226.7,291.8c6.9,1.5,13.8,2.7,20.7,3.5c0.3,0,0.6,0.2,0.8,0.4c0.8-2.4,1.5-4.9,2-7.3 c0.3-1.4,2.5-0.8,2.2,0.6c-1.3,5.6-3.2,11.1-5.7,16.4c-0.6,1.3-2.6,0.2-1.9-1.1c1-2.2,1.9-4.5,2.8-6.7h-0.1 c-7.2-0.8-14.3-2-21.3-3.6C224.7,293.6,225.3,291.5,226.7,291.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M245.2,307.7c1.8,3.1,4.2,5.8,6.9,8c1.1,0.9-0.5,2.5-1.6,1.6c-2.9-2.4-5.4-5.2-7.3-8.4 c-0.2-0.6,0-1.2,0.6-1.5C244.3,307.2,244.9,307.3,245.2,307.7L245.2,307.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M259.2,300.4c0,0-17.9-14.4-29.8-16.1s-18.1,11.2-17.2,19.8s29.3,13.4,29.3,13.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10_team-presentation-9-12",
    d: "M249.7,305.1c-2.3-2.2-32.7-16.4-43.4-9.9s-10,11.3-8.7,19.2s11.7,50.4,11.7,50.4c7.8,3,16.3,3.4,24.3,1.1 l-3-31.6l40.5-22.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M271.8,254.3c-1.6,1.2-15.5,2.9-18.4,9.2s-7.3,39.4-7.3,39.4s8.3,12.4,22.8,8c4.3-1.3,26.5-41.9,27.1-46.1 C297.5,253.9,271.8,254.3,271.8,254.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M266.5,233c-0.2,1.2-2.3,18.1,2.7,21.9c5,3.8,16.2-5.2,16.5-9.6s4.1-13.7-0.7-16.1S267.9,224.7,266.5,233z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9_team-presentation-9-12",
    d: "M266.5,233c0,0-4.2-3.2-4.9-6.2s2.9-5,6.4-5s6.5,0.9,9.6-0.9c3.3-1.9,7.4-1.9,10.7,0c2.9,1.9,3.3,6.7,5.3,9.1 s5.6,2.7,5.5,7.2s-6.7,5-7.2,8s-2.1,7.4-6.1,8.2s-9.6,0.9-10.1,0.2s2.6-10.7-0.2-11.4S266.3,240.1,266.5,233z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8_team-presentation-9-12",
    d: "M218.5,287.6l-11.1-4.6c0,0-3.4-1.7-4-0.8s-7.9-1.7-10,0s2.6,9.1,6.8,10.4s18.3,4.1,18.3,4.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st11_team-presentation-9-12",
    d: "M253.4,263.6c0,0-7.4,24.1-12.8,26c-3.3,1.2-13.4-2-20.7-4.5c-4.8,3.1-8.1,8-9,13.6 c11.2,6.2,30.4,13,37.7,13.6c10.5,0.9,15.4-30.1,15.4-30.1L253.4,263.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Chair_1_team-presentation-9-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5_team-presentation-9-12",
    cx: 270.7,
    cy: 379.1,
    rx: 22.9,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5_team-presentation-9-12",
    points: "274.5,341.1 273.6,375.3 266.8,375.3 266.8,341.1 \t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7_team-presentation-9-12",
    d: "M299.2,325.6c0.7-1.7,1.3-3.4,1.7-5.1c3.4-13.4,5.6-63.4-16.9-61.4c-24.7,2.2-16.4,64.1-41.4,62.2 s-35.3,4.6-25.1,14.3C238.1,355,286.6,355.4,299.2,325.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComBackground);
export default __webpack_public_path__ + "static/media/com-background.868859842666eb600781c41de595bf5a.svg";
export { ForwardRef as ReactComponent };